<template>
  <div
    v-if="notBuyService"
    class="notBuyService"
  >
    <div class="boxService">
      <Icon
        type="md-close-circle"
        size="100"
        color="#cb2020"
      ></Icon>
      <h1>您未购买此服务或此服务已过期</h1>
    </div>
  </div>
  <div
    v-else
    class="makeoutInvoice"
  >
    <searchForm
      :search-items="searchItems"
      :params="params"
      @handle-search="handleSearch"
    >
      <template v-slot:btn>
        <Button
          type="success"
          style="margin-left: 10px;"
          @click="exportExcel()"
        >
          导出
        </Button>
      </template>
    </searchForm>
    <Row
      :gutter="16"
      class="btn-groups"
    >
      <Col span="3">
      <Button
        v-if="!isRedirect"
        type="primary"
        @click="searchQr"
      >
        游客开票地址
      </Button>
      </Col>
    </Row>
    <Table
      :columns="columns"
      :data="tableData"
      :loading="isLoading"
    ></Table>
    <div
      v-if="isRedirect"
      class="totalprice"
    >
      合计：不含税金额<span>{{ totalNontaxAmount }}</span>元
      <label style="padding-left:30px">税额</label><span>{{ totalTaxAmount }}</span>元
    </div>
    <Page
      :total="total"
      show-elevator
      show-sizer
      style="margin-top: 10px"
      @on-change="onPageChange"
      @on-page-size-change="onPageSizeChange"
    />

    <view-qrcode
      ref="viewQrcode"
      :code-txt="codeTxt"
      @load-complete="loadComplete"
    ></view-qrcode>

    <Modal
      v-model="invoiceCancelModal"
      title="发票作废"
    >
      <Form
        ref="invoiceFormValidate"
        :model="invoiceCancelForm"
        :rules="invoiceCancelRule"
        :label-width="140"
      >
        <FormItem
          label="作废原因："
          prop="remark"
        >
          <Input
            v-model="invoiceCancelForm.remark"
            type="textarea"
            maxlength="80"
            placeholder="请输入作废原因"
            style="width: 300px"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="onInvoiceCancel">
          取消
        </Button>
        <Button
          type="primary"
          @click="onInvoiceOk('invoiceFormValidate')"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import searchForm from './searchForm';
import viewQrcode from './viewQrcode';
import { invoiceGridList, invoiceRed, exportExcelRecords, invoiceCancel } from '../../api/electronicInvoice';
import { indInvoiceList, indInvoiceTotalPrice, invoiceExport } from '../../api/independentInvoice';
import { getCountTime } from '../../utils/tools';
import { invoiceStatus } from '../../utils/mapState';

const days = getCountTime(7);

export default {
  name: 'ElectronicInvoiceApi',
  components: {
    searchForm,
    viewQrcode,
  },
  data() {
    return {
      codeTxt: '',
      notBuyService: false,
      isLoading: false,
      qrcodeLoading: false,
      applierId: null,
      isRedirect: false,
      applySubjectId: null,
      searchItems: [
        {
          label: '交易订单号',
          type: 'input',
          name: 'thirdSerialNo',
        },
        {
          label: '开票主体',
          type: 'input',
          name: 'saleDutyName',
        },
        {
          label: '业务方订单号',
          type: 'input',
          name: 'orderNo',
        },
        {
          label: '业务方明细号',
          type: 'input',
          name: 'orderDetailNo',
        },
        {
          label: '购方名称',
          type: 'input',
          name: 'buyDutyName',
        },
        {
          label: '手机号',
          type: 'input',
          name: 'buyTel',
        },
        {
          label: '邮箱',
          type: 'input',
          name: 'receiveEmail',
        },
        {
          label: '开票开始日期',
          type: 'date',
          name: 'startTime',
          today: days.t2,
        },
        {
          label: '开票结束日期',
          type: 'date',
          name: 'endTime',
          today: days.t1,
        },
      ],
      columns: [
        {
          title: '交易号 | 开票时间',
          align: 'center',
          // width:210,
          key: 'thirdSerialNo',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: `${params.row.thirdSerialNo}</br>${params.row.invoiceTime}`,
              },
            });
          },
        },
        {
          title: '发票代码 | 发票号码',
          align: 'center',
          // width:150,
          key: 'invoiceCode',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: `${
                  params.row.invoiceCode ? params.row.invoiceCode : ''
                }</br>${params.row.invoiceNo ? params.row.invoiceNo : ''}`,
              },
            });
          },
        },
        {
          title: '姓名 | 手机',
          align: 'center',
          // width:150,
          key: 'buyDutyName',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: `${params.row.buyDutyName}</br>${params.row.buyTel}`,
              },
            });
          },
        },
        {
          title: '邮箱 | 下载地址',
          align: 'center',
          key: 'receiveEmail',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML:
                  `${params.row.receiveEmail}</br>` +
                  `<a href="${params.row.downloadUrl}" target="_blank">${
                    params.row.downloadUrl ? params.row.downloadUrl : ''
                  }</a>`,
              },
            });
          },
        },
        {
          title: '名称 | 明细总数',
          align: 'center',
          //  width:150,
          key: 'goodsDetail',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: `${params.row.goodsDetail}</br>${params.row.goodsNum}`,
              },
            });
          },
        },
        {
          title: '不含税金额 | 合计税额',
          align: 'center',
          //  width:160,
          key: 'nontaxAmount',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: `${params.row.nontaxAmount}</br>${params.row.taxAmount}`,
              },
            });
          },
        },
        {
          title: '开票主体',
          key: 'companyName',
          //  width:150,
          align: 'center',
        },
        {
          title: '请求状态 | 返回状态',
          key: 'requestStatus',
          // width:180,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: `${params.row.requestStatus}</br>${
                  invoiceStatus[params.row.queryStatus]
                }`,
              },
            });
          },
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            const _this = this;
            const { id, queryStatus, type } = params.row;

            const red = h(
              'Button',
              {
                props: {
                  size: 'small',
                  type: 'primary',
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '提示',
                      content: '是否红冲当前电子发票?',
                      onOk() {
                        _this.invoiceRed(id);
                      },
                      onCancel() {},
                    });
                  },
                },
              },
              '红冲',
            );

            const abandone = h(
              'Button',
              {
                style: {
                  marginLeft: '10px',
                },
                props: {
                  size: 'small',
                  type: 'primary',
                },
                on: {
                  click: () => {
                    this.abandoneId = id;
                    this.invoiceCancelForm.remark = '';
                    this.invoiceCancelModal = true;
                  },
                },
              },
              '作废',
            );
            const actions = h('div', [red, abandone]);
            return Number(queryStatus) === 2 && type === 'blue' ? actions : null;
          },
        },
      ],
      tableData: [],
      total: 0,
      totalNontaxAmount: '',
      totalTaxAmount: '',
      params: {
        page: 1,
        limit: 10,
        sort: 'createTime',
        order: 'desc',
        startTime: days.t2,
        endTime: days.t1,
      },
      url: '/manage/eInvoice/webApi/einvoiceList/invoiceGrid',
      invoiceQueryStatus: [],
      invoiceCancelModal: false,
      invoiceCancelForm: {
        remark: '',
      },
      invoiceCancelRule: {
        remark: [
          {
            required: true,
            message: '请输入作废原因',
            trigger: 'blur',
          },
        ],
      },
      abandoneId: '',
    };
  },
  created() {
    // 外部链接直接跳转的发票，不需要login的
    this.applierId = this.$route.query.applierId || null;
    this.applySubjectId = this.$route.query.applySubjectId || null;
    if (this.$route.query.applySubjectId) {
      this.columns = this.columns.slice(0, this.columns.length - 1);
      this.isRedirect = true;
    }
  },
  mounted() {
    this.getList();
    if (this.$route.query.applySubjectId) {
      this.getTotalPrice();
    }
  },
  methods: {
    onInvoiceOk(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.invoiceCancel();
        }
      });
    },
    onInvoiceCancel() {
      this.invoiceCancelModal = false;
      this.$refs.invoiceFormValidate.resetFields();
    },
    invoiceCancel() {
      const params = {
        id: this.abandoneId,
        remark: this.invoiceCancelForm.remark,
      };
      invoiceCancel(params).then(res => {
        if (Number(res.status) === 200) {
          this.$Message.success('作废成功');
          this.getList();
        }
        this.invoiceCancelModal = false;
        this.$refs.invoiceFormValidate.resetFields();
      }).catch(err => {
        this.$Message.error(err.message || '作废失败');
      });
    },
    getTotalPrice() {
      if (this.$route.query.applierId) {
        this.params.applierId = this.$route.query.applierId;
      }
      this.params.applySubjectId = this.applySubjectId;
      indInvoiceTotalPrice(this.params, this.$route.query.corpCode)
        .then((res) => {
          this.totalNontaxAmount = res.data && res.data.totalNontaxAmount ? res.data.totalNontaxAmount : 0;
          this.totalTaxAmount = res.data && res.data.totalTaxAmount ? res.data.totalTaxAmount : 0;
        })
        .catch((err) => {
          this.$Message.error(err.message || '请求失败');
        });
    },
    getList() {
      this.isLoading = true;
      if (this.isRedirect) {
        this.params.applySubjectId = this.applySubjectId;
        if (this.$route.query.applierId) {
          this.params.applierId = this.$route.query.applierId;
        }
        indInvoiceList(this.params, this.$route.query.corpCode)
          .then((res) => {
            this.total = res.data.total;
            this.tableData = res.data.rows;
            this.isLoading = false;
          })
          .catch((err) => {
            this.$Message.error(err.message || '请求失败');
            this.isLoading = false;
          });
      } else {
        invoiceGridList(this.params)
          .then((res) => {
            this.total = res.data.total;
            this.tableData = res.data.rows;
            this.isLoading = false;
          })
          .catch((err) => {
            this.$Message.error(err.message || '请求失败');
            this.isLoading = false;
          });
      }
    },
    onPageChange(page) {
      this.params.page = page;
      this.getList();
    },
    onPageSizeChange(size) {
      this.params.page = 1;
      this.params.limit = size;
      this.getList();
    },
    handleSearch(params) {
      this.params.page = 1;
      this.params = { ...this.params, ...params };
      this.getList();
      if (this.isRedirect) {
        this.getTotalPrice();
      }
    },
    exportExcel() {
      if (this.isRedirect) {
        this.params.applySubjectId = this.applySubjectId;
        if (this.$route.query.applierId) {
          this.params.applierId = this.$route.query.applierId;
        }
        this.params.corpCode = this.$route.query.corpCode;
        invoiceExport(this.params).then(() => {
          this.$Message.success('导出成功');
        });
      } else {
        exportExcelRecords(this.params).then(() => {
          this.$Message.success('导出成功');
        });
      }
    },
    searchQr() {
      this.codeTxt = '';
      this.qrcodeLoading = true;
      this.$refs.viewQrcode.open();
    },
    loadComplete() {
      this.qrcodeLoading = false;
    },
    invoiceRed(id) {
      invoiceRed({ id })
        .then((res) => {
          this.$Message.success('红冲成功');
          this.getList();
        })
        .catch((err) => {
          this.$Message.error(err.message || '红冲失败');
        });
    },
  },
};
</script>

<style>
  @import url('./index.css');
</style>




// WEBPACK FOOTER //
// node_modules/@sditest/electronic-invoice-api/src/components/electronicInvoiceApi/index.vue